import type { FC } from "react"
import { Button, Icon, Link, Stack, Text } from "@chakra-ui/react"

import CardContainer from "common/components/CardContainer"
import ExternalLink from "ui/components/icons/ExternalLink"
import { EXTERNAL_ROUTES } from "common/constants/routes"
import type { OrganizationAnnouncement } from "organization/helpers/fetcher"
import MarkdownViewer from "common/components/MarkdownViewer"

const DelegatesInfoCard: FC<{
  organizationAnnouncement?: OrganizationAnnouncement
}> = ({ organizationAnnouncement }) => {
  const content =
    organizationAnnouncement?.delegatesInfoCard ??
    "Delegates create and vote on proposals. Token holders can update their delegate at any time."

  return (
    <CardContainer title="Who are the delegates?">
      <Stack direction="column" pt={{ base: 2, md: "auto" }} spacing={4}>
        <Text color="gray.500" fontSize="sm" fontWeight="regular">
          <MarkdownViewer content={content} />
        </Text>
        <Link isExternal href={EXTERNAL_ROUTES.tally.docs.delegationsOnTally()}>
          <Button
            color="gray.800"
            rightIcon={<Icon as={ExternalLink} h={3} w={3} />}
            variant="link"
          >
            Learn more
          </Button>
        </Link>
      </Stack>
    </CardContainer>
  )
}
export default DelegatesInfoCard
